import styled from 'styled-components'

const Container = styled.div`
    display: grid;
    grid-template-columns: 253px 1fr;
    grid-gap: 30px;
    .MuiTab-wrapper {
    align-items: flex-start;
}
.MuiTab-root {
    padding: 15px 12px !important;
    border-bottom: 1px solid #ccc;
    text-transform: none;
}
.MuiTabs-flexContainerVertical {
    border: 1px solid #ccc;
    border-bottom: none;
    border-radius: 7px;
    overflow: hidden;
}
@media (max-width: 650px) {
    grid-template-columns: 1fr;
    }
`;
const TabsWrapper = styled.div`
   
`

const AccordionContainer = styled.div`
    .MuiAccordionSummary-content {
        font-family: "latobold";
    }
`
const WebView = styled.div`
    display : block;
    @media (max-width: 650px) {
        display: none;
    }
`
const MobileView = styled.div`
 display : none;

    @media (max-width: 650px) {
        display: block;
        overflow: auto;
        ::after {
     display: inline-block;
     background-color: red;
     height: 50px;
     width:100%;
 }
    }
`

export {Container,TabsWrapper,AccordionContainer, WebView, MobileView};